<template lang="pug" src="./slider-meet-office.pug"></template>

<script>
import SliderOfficeDirective from './slider-meet-office.directive'

export default {
  props: ['props'],
  directives: {
    SliderOfficeDirective
  }
}
</script>



// WEBPACK FOOTER //
// slider-meet-office.vue?054c34ae